
import React from 'react';
import { Link } from 'react-router-dom';

const CustomerInfoGuide = () => {
  return (
    <div className="bg-white p-8 w-full max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-200">
        使い方 - お客様情報
      </h1>
      <p className="text-lg text-gray-800 mb-6">
        「お客様情報」では、登録情報の確認・変更および、お支払い用クレジットカードの管理を行うことができます。
      </p>

      <hr className="my-8 border-gray-200" />

      {/* Section 1: Changing Registration Details */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">ご登録内容の変更</h2>
        <p className="mb-4 text-gray-700">
          「編集」ボタンをクリックすると、登録情報の変更ができます。<br />
          「ログインパスワード変更」ボタンをクリックすると、新しいパスワードを設定できます。
        </p>
        
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6" role="alert">
          <p className="font-bold">注意</p>
          <p className="mt-2">一部の項目は、契約者情報・利用者情報として登録されているため、変更することができません。</p>
        </div>
      </section>

      <hr className="my-8 border-gray-200" />

      {/* Section 2: Email Notification Settings */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">メール受信設定</h2>
        <p className="mb-4 text-gray-700">
          メール受信設定では、Billwaveから送信されるメールの受信可否を設定できます。
        </p>
        <p className="mb-6 text-gray-700">
          設定はユーザーごとに保存され、他のユーザーには影響しません。
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">設定方法</h3>
        <p className="mb-4 text-gray-700">
          メニューの「お客様情報」にある「メール受信設定」にある各通知のトグルをオン・オフして設定します。
        </p>
        <p className="mb-6 text-gray-700">
          変更した内容は自動的に保存されます。
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">通知の種類</h3>
        <div className="space-y-4 mb-6">
          <div>
            <h4 className="font-bold text-gray-800 underline">重要なお知らせ</h4>
            <p className="text-gray-700 mt-1">
              サービスのご利用に関わる重要なご案内やセキュリティに関する通知です。<br />
              この通知は常に受信され、オフにすることはできません。
            </p>
          </div>
          <div>
            <h4 className="font-bold text-gray-800 underline">障害・メンテナンス情報</h4>
            <p className="text-gray-700 mt-1">
              システム障害や復旧情報、計画メンテナンスのお知らせを受信します。<br />
              不要な場合はオフにできます。
            </p>
          </div>
          <div>
            <h4 className="font-bold text-gray-800 underline">シグナルからのお知らせ</h4>
            <p className="text-gray-700 mt-1">
              新機能の追加やサービス改善、キャンペーンなどのお知らせを受信します。<br />
              不要な場合はオフにできます。
            </p>
          </div>
        </div>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">初期設定</h3>
        <p className="text-gray-700">
          初回はすべての通知がオンに設定されています。<br />
          なお、「重要なお知らせ」は常にオンとなり、変更することはできません。
        </p>
      </section>

      <hr className="my-8 border-gray-200" />

      {/* Section 3: Registering Payment Method */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">お支払い方法の登録</h2>
        <p className="mb-4 text-gray-700">
          有料プランの利用や、フリープランで上限を超えて請求書発行を行う場合に必要な、クレジットカード情報を登録できます。
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-4">
            <li>複数のカードを登録した場合、最後に登録したカードがデフォルト（支払い用）として設定されます。</li>
            <li>デフォルトのカードは、「デフォルトにする」をクリックすることで変更できます。</li>
        </ul>
      </section>

      <div className="mt-8 text-center">
        <Link 
          to="/support/how-to-use"
          className="inline-block bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-6 rounded-lg transition-colors"
        >
          「使い方」一覧へ戻る
        </Link>
      </div>

    </div>
  );
};

export default CustomerInfoGuide;
